var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'accordion__item',
        {
            'accordion__item--open': _vm.open,
            'accordion__item--hightlight': _vm.shouldHighlight,
        } ]},[_c('div',{staticClass:"accordion__heading",on:{"click":function($event){return _vm.$emit('toggle')}}},[_c('div',{staticClass:"heading__content"},[_vm._t("heading")],2),_c('ActionToggle',{staticClass:"heading__toggle",attrs:{"open":_vm.open,"title":_vm.toggleTitle}})],1),_c('div',{staticClass:"accordion__content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }